
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import './App.css';
import Appon from "./pages/Appon/Appon";
import Blog1 from "./pages/Blog1/Blog1";
import Home from './pages/Home/Home';
import SportsBike from "./pages/SportsBike/SportsBike";


function App() {
  return (
  <div>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />}> </Route>
      <Route path="home" element={<Home />}> </Route>
      <Route path="sportsBike" element={<SportsBike />}>
      </Route>
      <Route path="appon" element={<Appon />}>
      </Route>
      <Route path="blog1" element={<Blog1 />}>
      </Route>
    </Routes>
  </BrowserRouter>
   
  </div>
  );
}

export default App;
